import useEffectOnce from '@shared/hooks/useEffectOnce';
import { useTexts } from 'utils/useTexts';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { AssetLinks } from '@assets/assets';
import { useAnalyticsContext } from '@context/analyticsContext';

const FailRecaptcha = () => {
  const { t } = useTexts();
   const {analyticsState} = useAnalyticsContext();

   const { trackClick, trackPage } = useAnalytics({
     flow_step :analyticsState?.parameters?.flow_step,
     flow_stage: analyticsState?.parameters?.flow_stage,
   },false);

  useEffectOnce(() => trackPage('Failed Google Recaptcha'));

  const handlePhoneNumberClick = () => {
    trackClick('CTA Clicked', {
      cta_text: 'Call'+t('contactPhoneNumber'),
      cta_type: 'phone',
      cta_context: 'off-ramp',
      interaction_type: 'cta_click',
      destination_url: 'tel:'+t('contactPhoneNumber'),
      value: 75,
      currency: 'USD',
    });
  };

  return (
    <div className="iLendingCDX-fail-recaptcha-container">
      <h1 className="iLendingCDX-fail-recaptcha-title">{t('failRecaptcha.title')}</h1>
      <p className="iLendingCDX-fail-recaptcha-description">{t('failRecaptcha.text')}</p>
      <h2 className="iLendingCDX-fail-recaptcha-subtitle iLendingCDX-mt-4">{t('failRecaptcha.subtitle')}</h2>

      <ul className="iLendingCDX-fail-recaptcha-list">
        <li className="iLendingCDX-fail-recaptcha-list-item">
          <img
            className="call-icon"
            src={AssetLinks.phoneCall}
            alt="Call"
          />
          <div className="iLendingCDX-call-info">
            <a
              className="iLendingCDX-call-us-text"
              href={'tel:' + t('contactPhoneNumber').replace(/-/g, '')}
              onClick={handlePhoneNumberClick}
            >
              {t('failRecaptcha.callUs')} {t('contactPhoneNumber')}
            </a>
            <p className="iLendingCDX-call-description">{t('failRecaptcha.callUsDescription')}</p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default FailRecaptcha;
